(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@material-ui/core/styles"), require("@material-ui/core/utils"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "@material-ui/core/styles", "@material-ui/core/utils"], factory);
	else if(typeof exports === 'object')
		exports["default"] = factory(require("react"), require("@material-ui/core/styles"), require("@material-ui/core/utils"));
	else
		root["default"] = factory(root["react"], root["@material-ui/core/styles"], root["@material-ui/core/utils"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__9__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 322);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),

/***/ 28:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var warning__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14);
/* harmony import */ var warning__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(warning__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9);
/* harmony import */ var _material_ui_core_utils__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_utils__WEBPACK_IMPORTED_MODULE_4__);
var _excluded = ["classes", "children", "inline", "forceFullWidth", "backgroundColor", "p", "px", "py", "pt", "pr", "pb", "pl", "m", "mx", "my", "mt", "mr", "mb", "ml", "nm", "nmx", "nmy", "nmt", "nmr", "nmb", "nml", "className"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

 // $FlowFixMe



 // $FlowFixMe



var generatePropertyStyles = function generatePropertyStyles(theme, prefix, property) {
  var sign = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var variations = ['t', 'r', 'b', 'l'];
  var classes = {};
  var spacing = theme.extras.spacing;
  variations.forEach(function (variation) {
    spacing.spaces.forEach(function (value, index) {
      if (variation === 't') {
        classes["".concat(prefix).concat(variation, "-").concat(index)] = _defineProperty({}, "".concat(property, "Top"), value * sign);
      }

      if (variation === 'r') {
        classes["".concat(prefix).concat(variation, "-").concat(index)] = _defineProperty({}, "".concat(property, "Right"), value * sign);
      }

      if (variation === 'b') {
        classes["".concat(prefix).concat(variation, "-").concat(index)] = _defineProperty({}, "".concat(property, "Bottom"), value * sign);
      }

      if (variation === 'l') {
        classes["".concat(prefix).concat(variation, "-").concat(index)] = _defineProperty({}, "".concat(property, "Left"), value * sign);
      }
    });
  });
  return classes;
};

var styles = function styles(theme) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    root: {
      display: 'block',
      // If used within any flex box containers, like <Grid> it should expand.
      flexGrow: 1
    },
    rootInline: {
      display: 'inline-flex',
      flexGrow: 0
    }
  }, generatePropertyStyles(theme, 'p', 'padding')), generatePropertyStyles(theme, 'm', 'margin')), generatePropertyStyles(theme, 'nm', 'margin', -1)), {}, {
    forceFullWidth: {
      width: '100%'
    },
    backgroundColorTransparent: {},
    backgroundColorShaded: {
      backgroundColor: theme.palette.background["default"]
    },
    backgroundColorPaper: {
      backgroundColor: theme.palette.background.paper
    }
  });
};

var Box = function Box(_ref) {
  var _ref3;

  var classes = _ref.classes,
      children = _ref.children,
      _ref$inline = _ref.inline,
      inline = _ref$inline === void 0 ? false : _ref$inline,
      forceFullWidth = _ref.forceFullWidth,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'transparent' : _ref$backgroundColor,
      p = _ref.p,
      px = _ref.px,
      py = _ref.py,
      pt = _ref.pt,
      pr = _ref.pr,
      pb = _ref.pb,
      pl = _ref.pl,
      m = _ref.m,
      mx = _ref.mx,
      my = _ref.my,
      mt = _ref.mt,
      mr = _ref.mr,
      mb = _ref.mb,
      ml = _ref.ml,
      nm = _ref.nm,
      nmx = _ref.nmx,
      nmy = _ref.nmy,
      nmt = _ref.nmt,
      nmr = _ref.nmr,
      nmb = _ref.nmb,
      nml = _ref.nml,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var theme = Object(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__["useTheme"])();

  var _ref2 = theme.extras.spacing || {},
      steps = _ref2.steps;

  [p, px, py, pt, pr, pb, pl, m, mx, my, mt, mr, mb, ml, nm, nmx, nmy, nmt, nmr, nmb, nml].forEach(function (prop) {
    if (prop !== undefined) {
      warning__WEBPACK_IMPORTED_MODULE_2___default()(prop < steps, "<Box>: Maximum supported step value is ".concat(steps - 1, ". You have provided ").concat(prop, "."));
    }
  });
  var spacingClasses = []; // mt

  if (mt || my || m) {
    spacingClasses.push(classes["mt-".concat(mt || my || m || '')]);
  } // mb


  if (mb || my || m) {
    spacingClasses.push(classes["mb-".concat(mb || my || m || '')]);
  } // mr


  if (mr || mx || m) {
    spacingClasses.push(classes["mr-".concat(mr || mx || m || '')]);
  } // ml


  if (ml || mx || m) {
    spacingClasses.push(classes["ml-".concat(ml || mx || m || '')]);
  } // nmt


  if (nmt || nmy || nm) {
    spacingClasses.push(classes["nmt-".concat(nmt || nmy || nm || '')]);
  } // nmb


  if (nmb || nmy || nm) {
    spacingClasses.push(classes["nmb-".concat(nmb || nmy || nm || '')]);
  } // nmr


  if (nmr || nmx || nm) {
    spacingClasses.push(classes["nmr-".concat(nmr || nmx || nm || '')]);
  } // nml


  if (nml || nmx || nm) {
    spacingClasses.push(classes["nml-".concat(nml || nmx || nm || '')]);
  } // pt


  if (pt || py || p) {
    spacingClasses.push(classes["pt-".concat(pt || py || p || '')]);
  } // pb


  if (pb || py || p) {
    spacingClasses.push(classes["pb-".concat(pb || py || p || '')]);
  } // pr


  if (pr || px || p) {
    spacingClasses.push(classes["pr-".concat(pr || px || p || '')]);
  } // pl


  if (pl || px || p) {
    spacingClasses.push(classes["pl-".concat(pl || px || p || '')]);
  }

  var classesName = classnames__WEBPACK_IMPORTED_MODULE_3___default.a.apply(void 0, [classes.root, (_ref3 = {}, _defineProperty(_ref3, classes.rootInline, inline), _defineProperty(_ref3, classes.forceFullWidth, forceFullWidth), _defineProperty(_ref3, classes["backgroundColor".concat(Object(_material_ui_core_utils__WEBPACK_IMPORTED_MODULE_4__["capitalize"])(backgroundColor))], backgroundColor), _ref3)].concat(spacingClasses, [className]));
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", _extends({
    className: classesName
  }, restProps), children);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__["withStyles"])(styles)(Box));

/***/ }),

/***/ 322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Box_jsx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28);

/* harmony default export */ __webpack_exports__["default"] = (_Box_jsx__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__9__;

/***/ })

/******/ });
});